import { AnyAction } from 'redux';

import {
  AI_DISCLAIMER_TOGGLE,
  FETCH_ASSESSMENT_ERROR,
  FETCH_ASSESSMENT_START,
  FETCH_ASSESSMENT_SUCCESS,
  SSI_DOCUMENT_NUMBER_CHANGE,
} from 'actions/assessment/types';
import {
  IAIDisclaimer,
  IFetchAssessmentError,
  IFetchAssessmentSuccess,
  ISsiDocumentNumberChange,
} from 'actions/assessment';
import { SsiDocument } from 'types/check';
import { Error } from 'types/error';

export type AssessmentReducerType = {
  isLoading: boolean;
  jobToken: string;
  pagesCounter: number;
  selectedSsiDocumentNumber: string[];
  assessmentSsiVersions: SsiDocument[] | [];
  isBrandedDocument: boolean;
  isDisclaimerOpen: boolean;
  error: Error | null;
};

export const initialState = (): AssessmentReducerType => ({
  isLoading: true,
  jobToken: '',
  pagesCounter: 0,
  selectedSsiDocumentNumber: [],
  assessmentSsiVersions: [],
  isBrandedDocument: false,
  isDisclaimerOpen: false,
  error: null,
});

function handleSsiDocumentNumberChange(
  state: AssessmentReducerType,
  action: ISsiDocumentNumberChange
) {
  return {
    ...state,
    selectedSsiDocumentNumber: action.selectedSsiDocumentNumber,
  };
}

function handleFetchAssessmentStart(state: AssessmentReducerType) {
  return {
    ...state,
    isLoading: true,
  };
}

function toggleDisclaimerModal(
  state: AssessmentReducerType,
  action: IAIDisclaimer
) {
  return {
    ...state,
    isDisclaimerOpen: action.isDisclaimerOpen,
  };
}

function handleFetchAssessmentSuccess(
  state: AssessmentReducerType,
  action: IFetchAssessmentSuccess
) {
  return {
    ...state,
    ...action.assessment,
    isLoading: false,
    isBrandedDocument: !!action.assessment.assessmentSsiVersions[0],
  };
}

function handleFetchAssessmentError(
  state: AssessmentReducerType,
  action: IFetchAssessmentError
) {
  return {
    ...state,
    isLoading: false,
    error: { ...action.error },
  };
}

export default function AssessmentReducer(
  state = initialState(),
  action: AnyAction
) {
  switch (action.type) {
    case AI_DISCLAIMER_TOGGLE:
      return toggleDisclaimerModal(state, action as IAIDisclaimer);
    case FETCH_ASSESSMENT_START:
      return handleFetchAssessmentStart(state);
    case FETCH_ASSESSMENT_SUCCESS:
      return handleFetchAssessmentSuccess(
        state,
        action as IFetchAssessmentSuccess
      );
    case FETCH_ASSESSMENT_ERROR:
      return handleFetchAssessmentError(state, action as IFetchAssessmentError);
    case SSI_DOCUMENT_NUMBER_CHANGE:
      return handleSsiDocumentNumberChange(
        state,
        action as ISsiDocumentNumberChange
      );
    default:
      return state;
  }
}
